import { SettingDTO } from 'src/dtos/SettingDTO';
import { Utility } from 'src/services/utility.service';

export class Setting {
  public value: string | number | boolean | null;
  public key!: string;
  public enterpriseId?: number;
  public stationId?: number;
  public userId?: number;
  public level?: number;

  constructor(dto: SettingDTO) {
    this.value = dto.value ? Utility.convertSettingsValue(dto.value) : null;
    this.key = dto.key;
    this.enterpriseId = dto.enterpriseId;
    this.stationId = dto.stationId;
    this.userId = dto.userId;
    this.level = dto.level ?? 500;
  }
}
